<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mBakFZ/tc-custom/9781625849427.jpg?1736611395317" alt="This image is the cover for the book Warren G. Harding & the Marion Daily Star"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warren G. Harding & the Marion Daily Star
      </h1>
      <p class="bookDescription body article font2">
        <b>How a committed journalist transformed a small town daily newspaper—and how that editorial success inspired his policies as President of the United States.</b><br/>  <br/> President Warren G. Harding’s thirty-nine-year career as a newspaperman is often treated as a footnote. This book offers a unique approach to the Harding story, presenting him as he saw himself: as a newspaperman. His political successes were based on the thinking of a newspaper editor—balancing all of the facets of an issue, examining the facts and weighing the effect on the constituents. Even his approach to balancing the federal budget was built on early experience at his small, struggling newspaper, where his motto was: “All paid in, all paid out, books even.” The only member of the Fourth Estate to enter the White House, Harding found his voice through the pages of the <i>Marion Daily Star</i>. Author Sheryl Smart Hall offers an intimate view of the man, often as seen through the eyes of those who knew him best—his co-workers at the <i>Star</i>.<br/>  <br/> Includes photos
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheryl Smart Hall, Edward Looman
      </h2>
      
      <p class="authorDescription body article">Sherry Smart Hall was the Sunday edition editor at the Marion Star and a copy editor and bureau chief at the Canton (OH) Repository before working for the Harding Home Presidential Site in Marion. Hall served as the site's education coordinator for nine years, and then became site manager in 2009. A native of Marion, she graduated from Heidelberg University with majors in English and American studies.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?24d71d9e